import React, { useEffect, useState } from "react";
import "../../css/ProductListed.css";
import { ToastContainer, toast } from "react-toastify";
import { getDatabase, ref, onValue, remove, get } from "firebase/database";
import { getStorage, ref as sRef, deleteObject } from "firebase/storage";
import LoaderComponent from "../../component/LoaderComponent";
import AddCategoryModal from "../../component/AddCategoryModal";
import { useAdminAuth } from "../../component/AdminUserPresent";

const CategoryListed = () => {
	const [categories, setCategories] = useState([]);
	const [filtered, setFiltered] = useState([]);
	const [searchText, setSearchText] = useState("");
	const [loader, setLoader] = useState(false);
	const [openModal, setOpenModal] = useState(false);
	const [selectedCategory, setSelectedCategory] = useState(null);
    const [editCatFlag, setEditCatFlag] = useState(false);
	const isAdmin = useAdminAuth();
	const db = getDatabase();
	const storage = getStorage();

	// 🔹 Fetch categories
	useEffect(() => {
		if (!isAdmin) return;
		setLoader(true);
		const catRef = ref(db, "categories");
		const unsub = onValue(catRef, (snapshot) => {
			if (snapshot.exists()) {
				const data = snapshot.val();
				const list = Object.values(data);
				setCategories(list);
			} else {
				setCategories([]);
			}
            setEditCatFlag(false);
			setLoader(false);
		});

		return () => unsub();
	}, [db]);

	// 🔹 Search
	useEffect(() => {
		const text = searchText.trim().toLowerCase();
		if (text.length < 2) {
			setFiltered([]);
			return;
		}

		const result = categories.filter(
			(cat) =>
				cat.title.toLowerCase().includes(text) ||
				cat.path.toLowerCase().includes(text)
		);
		setFiltered(result);
	}, [searchText, categories]);

	// 🔹 Delete category
	// const handleDeleteCategory = async (category) => {
	// 	const confirmDelete = window.confirm(
	// 		"Are you sure you want to delete this category?"
	// 	);
	// 	if (!confirmDelete) return;

	// 	try {
	// 		setLoader(true);
	// 		// delete image
	// 		if (category.img) {
	// 			await deleteObject(sRef(storage, category.img));
	// 		}

	// 		// delete db entry
	// 		await remove(ref(db, `categories/${category.path}`));

	// 		toast.success("Category deleted successfully");
	// 	} catch (error) {
	// 		console.error(error);
	// 		setLoader(false);
	// 		toast.error("Failed to delete category");
	// 	} finally {
	// 		setLoader(false);
	// 	}
	// };


const handleDeleteCategory = async (category) => {
	const confirmDelete = window.confirm(
		"This will delete the category and ALL its products. Continue?"
	);
	if (!confirmDelete) return;

	try {
		setLoader(true);

		// 1️⃣ Get all products under category
		const productsRef = ref(db, `productDetails/${category.path}`);
		const snapshot = await get(productsRef);

		if (snapshot.exists()) {
			const products = snapshot.val();

			// 2️⃣ Loop through each product
			const deletePromises = Object.values(products).map(
				async (product) => {
					// 🔥 DELETE PRODUCT IMAGES (same logic as product delete)
					if (
						product.postImageArray &&
						product.postImageArray.length > 0
					) {
						await Promise.all(
							product.postImageArray.map(async (img) => {
								if (!img.url) return;

								const imageRef = sRef(
									storage,
									img.url
								);
								await deleteObject(imageRef);
							})
						);
					}

					// 🔥 DELETE PRODUCT DATA
					await remove(
						ref(
							db,
							`/productDetails/${category.path}/${product.productId}`
						)
					);
				}
			);

			await Promise.all(deletePromises);
		}

		// 3️⃣ Delete category image
		if (category.img) {
			await deleteObject(sRef(storage, category.img));
		}

		// 4️⃣ Delete category node
		await remove(ref(db, `categories/${category.path}`));

		toast.success("Category and all products deleted successfully");
	} catch (error) {
		console.error(error);
		toast.error("Failed to delete category");
	} finally {
		setLoader(false);
	}
};


	const list = filtered.length > 0 ? filtered : categories;

	return (
		<div>
			<ToastContainer />
			{loader && <LoaderComponent />}
			<div className="text-center pt-5 pb-4 product-listed-header">
				Product Categories
			</div>

			<div className="d-flex justify-content-between container mb-4">
				<input
					type="text"
					placeholder="Search category"
					className="search-input p-3 my-3"
					value={searchText}
					onChange={(e) => setSearchText(e.target.value)}
				/>

				<button
					className="add-category-card-btn"
					onClick={() => {
						setSelectedCategory(null);
						setOpenModal(true);
					}}
				>
					Add Category
				</button>
			</div>

			<div className="product-list-view container">
				<div className="table-wrapper">
					<table className="admin-table">
						<thead>
							<tr className="table-heading">
								<th>#</th>
								<th>Image</th>
								<th>Title</th>
								<th>Path</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							{list.length === 0 ? (
								<tr>
									<td colSpan="5" className="no-data">
										No categories found
									</td>
								</tr>
							) : (
								list.map((cat, index) => (
									<tr key={cat.path}>
										<td>{index + 1}</td>
										<td>
											<img
												src={cat.img}
												alt={cat.title}
												className="product-thumb"
											/>
										</td>
										<td>{cat.title}</td>
										<td>{cat.path}</td>
										<td className="text-center">
											<button
												className="btn edit-btn mb-2"
												onClick={() => {
													setSelectedCategory(cat);
													setOpenModal(true);
                                                    setEditCatFlag(true);
												}}
											>
												Edit
											</button>

											<button
												className="btn delete-btn mb-2"
												onClick={() =>
													handleDeleteCategory(cat)
												}
											>
												Delete
											</button>
										</td>
									</tr>
								))
							)}
						</tbody>
					</table>
				</div>
			</div>

			<AddCategoryModal
				isOpen={openModal}
				onClose={() => {
					setOpenModal(false);
					setSelectedCategory(null);
				}}
				editCategory={selectedCategory}
                editCatFlag = {editCatFlag}
			/>
		</div>
	);
};

export default CategoryListed;
